import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import api, { formatApiError } from "../lib/api";

export default function ResetPassword() {
    const [params] = useSearchParams();
    const navigate = useNavigate();
    const token = params.get("token") || "";
    const [password, setPassword] = useState("");
    const [confirm, setConfirm] = useState("");
    const [err, setErr] = useState("");
    const [done, setDone] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErr("");
        if (password !== confirm) { setErr("Le password non coincidono"); return; }
        setLoading(true);
        try {
            await api.post("/auth/reset-password", { token, password });
            setDone(true);
            setTimeout(() => navigate("/login", { replace: true }), 2200);
        } catch (e2) {
            setErr(formatApiError(e2.response?.data?.detail));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-white p-8" data-testid="reset-password-page">
            <div className="w-full max-w-md fade-up">
                <img src="/logo-full.png" alt="Asta Intelligence" className="h-24 w-auto mix-blend-screen mb-5" />
                <h1 className="font-display-black text-3xl sm:text-4xl mb-3 leading-[0.95]">Nuova password</h1>

                {!token ? (
                    <div data-testid="reset-password-invalid" className="border border-amber-200 bg-amber-50 text-amber-800 text-sm px-4 py-3 rounded-lg">
                        Link non valido. Richiedi un nuovo reset dalla pagina{" "}
                        <Link to="/forgot-password" className="underline font-semibold">Password dimenticata</Link>.
                    </div>
                ) : done ? (
                    <div data-testid="reset-password-success" className="border border-emerald-200 bg-emerald-50 text-emerald-800 text-sm px-4 py-3 rounded-lg">
                        Password reimpostata. Ti reindirizzo al login…
                    </div>
                ) : (
                    <>
                        <p className="text-sm text-gray-600 mb-8 leading-relaxed">
                            Scegli una nuova password (almeno 8 caratteri, una lettera e un numero).
                        </p>
                        <form onSubmit={handleSubmit} className="space-y-5" data-testid="reset-password-form">
                            <div>
                                <label className="overline block mb-2">Nuova password</label>
                                <input
                                    data-testid="reset-password-input"
                                    type="password" required autoComplete="new-password"
                                    value={password} onChange={(e) => setPassword(e.target.value)}
                                    className="w-full h-11 px-3 border border-gray-300 bg-white text-sm focus:border-black focus:outline-none transition-colors"
                                    placeholder="••••••••"
                                />
                            </div>
                            <div>
                                <label className="overline block mb-2">Conferma password</label>
                                <input
                                    data-testid="reset-password-confirm-input"
                                    type="password" required autoComplete="new-password"
                                    value={confirm} onChange={(e) => setConfirm(e.target.value)}
                                    className="w-full h-11 px-3 border border-gray-300 bg-white text-sm focus:border-black focus:outline-none transition-colors"
                                    placeholder="••••••••"
                                />
                            </div>
                            {err && <div data-testid="reset-password-error" className="border border-red-200 bg-red-50 text-red-700 text-xs px-3 py-2">{err}</div>}
                            <button
                                data-testid="reset-password-submit"
                                type="submit" disabled={loading}
                                className="w-full h-11 bg-black text-white text-sm font-semibold hover:bg-gray-800 disabled:opacity-40 transition-colors rounded-lg"
                            >
                                {loading ? "Salvataggio…" : "Reimposta password"}
                            </button>
                        </form>
                    </>
                )}

                <div className="mt-8 pt-6 border-t border-gray-200 text-xs text-gray-600">
                    <Link to="/login" className="font-semibold underline underline-offset-4 hover:text-black">← Torna al login</Link>
                </div>
            </div>
        </div>
    );
}
